import { defineComponent as _defineComponent } from 'vue'
import { ProductInterface } from './models/SuggestionInterface.ts';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Suggestion',
  props: {
    suggestion: { type: null, required: true },
    query: { type: null, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

    const props = __props;

    const highlightSuggestion = computed(() => {
        if (props.suggestion.value_highlighting) {
            return props.suggestion.value_highlighting;
        }

        return props.suggestion.mainValue.replace(
            new RegExp(props.query, 'gi'),
            (match) => {
                return ' <strong>' + match + '</strong>';
            }
        );
    });

const __returned__ = { props, highlightSuggestion }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})